import { ItemForSeat } from "../../model/Seating";
import { formatDate, formatTimeRange } from "./formatUtils";

type BuildOptions = {
    isPyt: boolean;
};

const formatPrice = (price: number): string => {
    // Preis in Cents
    return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(price / 100);
};

// Erzeugt textliche Zusammenfassung für ein Ticket.
// Ticket Nr, Einzelteile (Datum, Einlasszeit, Leistung) nur,
// wenn vorhanden und mit Komma getrennt. Bsp:
// "Ticket 2, 27.01.2025, Einlasszeit 15:30, Leistung Familienticket 16,50 EUR"
export const buildTicketSummary = (item: ItemForSeat, index: number, opts: BuildOptions): string => {
    const ticketNr = index + 1;

    let datePart = "";
    let timePart = "";

    if (opts.isPyt && item.row?.includes("|")) {
        const [iso, range] = item.row.split("|");
        if (iso) {
            datePart = formatDate(iso);
        }
        if (range) {
            timePart = `Einlasszeit ${formatTimeRange(range)}`;
        }
    } else {
        if (item.longDates) {
            datePart = item.longDates;
        }
    }

    const selectedDef = item.itemDefinitions?.find((d) => d.id === item.selectedItemDefinition);
    const servicePart = selectedDef
        ? `Leistung ${selectedDef.label} ${formatPrice(selectedDef.price)}`
        : "Leistung nicht gewählt";

    return [`Ticket ${ticketNr}`, datePart, timePart, servicePart].filter(Boolean).join(", ");
};

// Erzeugt sinnvollen Aria-Label-Text für den Cart-Bestellen-Button in Abhängigkeit vom Cart-Inhalt.
// Leer -> "Bestellen"
// Vorhandene Tickets -> Alle Tickets in ihrer Zusammenfassung mit Punkt getrennt, Bsp.:
// "Ticket 1, 27.01.2025, Einlasszeit 15:30, Leistung Familienticket 16,50 EUR,
// Ticket 2, 27.01.2025, Einlasszeit 15:30, Leistung Familienticket 16,50 EUR"
export const buildOrderButtonAriaLabel = (items: ItemForSeat[], opts: BuildOptions): string => {
    if (!items.length) {
        return "Bestellen";
    }
    const tickets = items.map((it, idx) => buildTicketSummary(it, idx, opts)).join(". ");
    return `${tickets}. Bestellen`;
};
